module.exports = "/static/images/close-modal.svg";